import React, { Component } from 'react'
import CommonTableModule from './../CommonTable/CommonTableModule';
import { Card, Alert, Spinner, Badge, Button, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import axios from "axios";
import { DateTimeFormat } from '../DateFormat/DateTimeFormat';
import CommonLoader from '../loaderComponent/CommonLoader';
import SearchBox from '../commonSearchBox/CommonSearchBox'
import debounce from "lodash/debounce";
import CommonToast from '../Toaster/CommonToast';

export default class GiveAuthorization extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissionData: [],
      loading: false,
      hasError: false,
      errMsg: "",
      searchTerm: "",
      roleId: this.props.match.params.id,
      PermissionCode: '',
      permissionCodeData: [],
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',

    };
    this.debouncedSearch = debounce(this.triggerSearch, 500);
  }


  async componentDidMount() {
    this.fetchPermissionCodes();
    this.fetchPermissionCodesByRoleId();
  }


  triggerSearch = () => {
    // this.fetchPermissionCodes(this.state.searchTerm);
    this.fetchPermissionCodesByRoleId(this.state.searchTerm);
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value }, () => {
      this.debouncedSearch();
    });
  };


  handleSearchClick = () => {
    this.debouncedSearch.cancel();
    // this.triggerSearch()
  };

  fetchPermissionCodesByRoleId = async (searchTerm = "") => {
    //this.setState({ });

    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({
        hasError: true,
        errMsg: "Unauthorized! Please log in.",
        loading: false
      });
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };
    const params = {};

    if (searchTerm) {
      params.search = searchTerm;
    }
    try {
      // const response = await axios.get(`/rolePermission/rolePermission/${this.state.roleId}`, {
      //   headers
      // });
      const response = await axios.get(
        `/rolePermission/rolePermission/${this.state.roleId}`,
        {
          headers,
          params, // <-- pass the search term here
        }
      );

      this.setState({ permissionCodeData: response?.data?.data, loading: false });
      // console.log("data by role id here,", response?.data?.data)
    } catch (error) {
      console.error("Error fetching permission code:", error);
      let errorMessage = "Failed to load permission code.";
      if (error.response?.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };


  fetchDelete = async (code) => {
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({
        hasError: true,
        errMsg: "Unauthorized! Please log in.",
        loading: false
      });
      return;
    }


    const payload = {
      role: this.state.roleId,
      code: code,
      // code: this.state.PermissionCode,
    };
    // console.log("this is my delete payload ,", payload)

    try {
      // const response = await axios.delete(`/rolePermission/delete`, { headers },payload);
      const response = await axios.delete('/rolePermission/delete', {
        headers: { Authorization: `Bearer ${token}` },
        data: payload
      });
      if (response) {
        this.setState({
          completed: true,
          toastMessage: response?.data?.message,
          toastVariant: 'success',
          color: 'green',
          showToast: true,
          code: "",
          name: "",
          errors: {}
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 1000);
      }
    } catch (error) {
      console.error("Error fetching permission code:", error);
      let errorMessage = "Failed to load permission code.";
      if (error.response?.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
        this.setState({
          completed: true,
          toastMessage: errorMessage,
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
          code: "",
          name: "",
          errors: {}
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 1000);
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }


  onUpdateAuthorization = async (rowData, isAuthorized) => {
    this.setState({
      loading: false
    })
    console.log("rowData is this", rowData);
    this.setState({ PermissionCode: rowData?.code });

    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        enabled: isAuthorized,
        role: this.state.roleId,
        code: rowData?.code,
      };
      if (!isAuthorized) {
        await this.fetchDelete(rowData?.code)
        this.fetchPermissionCodesByRoleId();
        return;

      }
      const res = await axios.post(`/rolePermission`, payload, { headers });
      console.log("res 143", res?.data.message);
      if (res.status === 200) {
        const updatedList = this.state.permissionCodeData.map(item =>
          item.id === rowData.id ? { ...item, status: isAuthorized } : item
        );
        console.log("updatedList ----pankaj", updatedList);
        // this.setState({ permissionCodeData: updatedList, loading: false });
        this.setState({
          completed: true,
          permissionCodeData: updatedList,
          toastMessage: res?.data.message,
          toastVariant: 'success',
          color: 'green',
          showToast: true,
          code: "",
          name: "",
          errors: {}
        });

        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 1000);
      }
    } catch (error) {
      this.setState({
        completed: true,
        toastMessage: `Error updating authorization status! || ${error}`,
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
        code: "",
        name: "",
        errors: {}
      });

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 1000);
      console.error("Error updating authorization status:", error);
    }
  };






  // onUpdateAuthorization = async (rowData, isAuthorized) => {
  //   console.log("rowData is this", rowData);
  //   this.setState({ PermissionCode: rowData?.code })
  //   console.log("isAuthorized", isAuthorized);

  //   try {
  //     //gger
  //     const token = localStorage.getItem("token");
  //     const headers = { Authorization: `Bearer ${token}` };
  //     const payload = {
  //       enabled: isAuthorized,
  //       role: this.state.roleId,
  //       code: rowData?.code,
  //     };
  //     // if (!isAuthorized) {
  //     //   this.fetchDelete()
  //     // }
  //     console.log("payload", payload);
  //     const res = await axios.post(`/rolePermission`, payload, { headers });
  //     // console.log("this is update api harsh,", res)
  //     if (res.status === 200) {
  //       this.fetchPermissionCodesByRoleId()
  //     }
  //   } catch (error) {
  //     console.error("Error updating authorization status:", error);
  //   }
  // };



  fetchPermissionCodes = async (searchTerm = "") => {
    this.setState({ loading: true });

    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({
        hasError: true,
        errMsg: "Unauthorized! Please log in.",
        loading: false
      });
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };
    const params = {};

    if (searchTerm) {
      params.search = searchTerm;
    }
    console.log("params0", params);
    try {
      const response = await axios.get("/permission", {
        headers,
        params
      });

      this.setState({ permissionData: response?.data, loading: false });
    } catch (error) {
      console.error("Error fetching permission code:", error);
      let errorMessage = "Failed to load permission code.";
      if (error.response?.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };

  handleBack = () => {
    this.props.history.push('/role-list')
  }
  render() {
    const columns = [
      { key: "id", label: "ID" },
      { key: "code", label: "Code" },
      { key: "name", label: "Name" },
      {
        key: "status",
        label: "Status",
        render: (value, rowData) => {
          console.log("rowData for btn", rowData.status);
          return (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-switch-${rowData?.id || "default"}`}>
                  Toggle Authorization
                </Tooltip>
              }
            >
              <div className='big-switch'>
                <Form.Check
                  type="switch"
                  id={`switch-${rowData?.id}`}
                  label=""
                  className='switch-pointer'
                  checked={rowData?.status === true ? true : false}
                  onChange={(e) => this.onUpdateAuthorization(rowData, e.target.checked)}
                />
              </div>
            </OverlayTrigger>
          );
        }
      }
    ];
    return (

      <div className="container-fluid pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <SearchBox
              searchTerm={this.state.searchTerm}
              onSearchChange={this.handleSearchChange}
              onSearchClick={this.handleSearchClick}
            />
          </div>
          <div>
            <Button variant='outline-primary' onClick={this.handleBack}><i className="fa fa-arrow-right"></i></Button>
          </div>
        </div>
        <CommonLoader isLoading={this.state.loading}>
          <Card className="mb-3">

            <Card.Body>
              {this.state.hasError ? (
                <Alert variant="outline-danger" className="m-3">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <CommonTableModule columns={columns} data={this.state.permissionCodeData} isSearchBoxEnabled={false} />
              )}
            </Card.Body>
          </Card>
        </CommonLoader>
      </div >
    )
  }
}

